import React from 'react';
import { Form } from 'formik';
import ProductCheckout from '../ProductCheckout';
import FormikWrapper from '../ProductCheckout/FormikWrapper';
import Container from './Container';
import TitleContainer from './title/TitleContainer';
import Title from './title/Title';
import Subtitle from './title/Subtitle';
import TitleLink from './title/TitleLink';
import FormContainer from './FormContainer';
import commercePropTypes from '../../prop-types/commercePropTypes';

var ProductShortDetails = function ProductShortDetails(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      price = _ref.price,
      currency = _ref.currency,
      discount = _ref.discount,
      index = _ref.index,
      availableStyles = _ref.availableStyles,
      onProductSubmit = _ref.onProductSubmit,
      onProductChange = _ref.onProductChange,
      productSlug = _ref.productSlug,
      isExternalCta = _ref.isExternalCta,
      ctaPath = _ref.ctaPath;
  var renderTitle = /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(Title, null, title), subtitle && /*#__PURE__*/React.createElement(Subtitle, null, subtitle));
  var renderProductTitle = productSlug ? /*#__PURE__*/React.createElement(TitleLink, {
    to: productSlug
  }, renderTitle) : renderTitle;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(TitleContainer, null, renderProductTitle), /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(FormikWrapper, {
    onProductSubmit: onProductSubmit,
    availableStyles: availableStyles
  }, function (_ref2) {
    var isSubmitting = _ref2.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, {
      noValidate: true
    }, /*#__PURE__*/React.createElement(ProductCheckout, {
      availableStyles: availableStyles,
      index: index,
      onProductChange: onProductChange,
      price: price,
      discount: discount,
      currency: currency,
      isSubmitting: isSubmitting,
      productSlug: productSlug,
      isExternalCta: isExternalCta,
      ctaPath: ctaPath
    }));
  })));
};

ProductShortDetails.defaultProps = {
  title: undefined,
  subtitle: undefined,
  price: undefined,
  discount: undefined,
  currency: undefined,
  onProductSubmit: null,
  onProductChange: null,
  productSlug: undefined,
  isExternalCta: false,
  ctaPath: null
};
export default ProductShortDetails;